/**
 * The tags screen's own catalogue (`Tags`, `CategoryPanel`, `NewCategory`).
 * No other module writes to it -- the collision `defineCatalogue` exists to
 * avoid (see `../pages/team.messages.ts` for the same reasoning).
 */

import { defineCatalogue } from '../../../i18n';

export const tagsCatalogue = defineCatalogue(
  {
    heading: 'Tags',

    'panel.title': 'Categorias',
    'panel.subtitle.one': '{active} de {total} ativa',
    'panel.subtitle.other': '{active} de {total} ativas',

    'row.accounts.one': '{count} conta',
    'row.accounts.other': '{count} contas',
    'row.unused': 'sem uso',
    'row.active': '"{category}" ativa',
    'row.actionsMenu': 'Ações de "{category}"',
    'row.rename': 'Renomear',
    'row.addValue': 'valor',
    'row.addValueLabel': 'Novo valor de "{category}"',
    'row.addValueSubmit': 'Adicionar valor',
    'row.addValueCancel': 'Cancelar',
    'row.remove': 'Excluir',
    'row.single': 'Uma por conta',
    'row.warning':
      'Este nome parece registrar religião, partido, saúde ou orientação sexual de uma pessoa. Tags descrevem contas; confira antes de usar.',
    'row.locked':
      'Obrigatória: toda conta tem exatamente um alinhamento. Dá para adicionar valores e trocar ícones.',

    'value.remove': 'Excluir valor',
    'value.countsAs': 'Conta como',
    'value.countsAsOption': 'conta como {value}',

    'icon.category': 'Ícone de "{name}"',
    'icon.value': 'Ícone de "{name}"',
    'icon.search': 'Buscar ícone',
    'icon.none': 'Nenhum ícone encontrado.',
    'icon.heading': 'Ícones',
    'icon.inheritCategory': 'Usar o ícone da categoria',
    'icon.inheritDefault': 'Usar o ícone padrão',

    'remove.title': 'Excluir "{name}"?',
    'remove.category.one':
      'A categoria e seus valores somem, e {count} conta perde essas marcações. Não dá para desfazer.',
    'remove.category.other':
      'A categoria e seus valores somem, e {count} contas perdem essas marcações. Não dá para desfazer.',
    'remove.value':
      'O valor some e as contas que o têm perdem essa marcação. Não dá para desfazer.',
    'remove.alignmentValue':
      'O valor some e as contas que o têm passam para "{fallback}". Não dá para desfazer.',
    'remove.submit': 'Excluir',

    'scope.label': 'Escopo de análise',
    'scope.ALL': 'Todas as publicações',
    'scope.RELATED': 'Só as relacionadas',
    'scope.help':
      'Define quais publicações das contas com este alinhamento recebem métricas, comentários, curtidas e análise de comentários.',

    'create.trigger': 'Nova tag',
    'create.title': 'Nova tag',
    'create.label': 'Nome da categoria',
    'create.submit': 'Criar',

    'rename.title': 'Renomear "{category}"',
    'rename.label': 'Novo nome',
    'rename.submit': 'Renomear',

    'empty.title': 'Nenhuma tag ainda',
    'empty.body': 'Crie uma tag para começar.',
  },
  {
    heading: 'Tags',

    'panel.title': 'Categories',
    'panel.subtitle.one': '{active} of {total} active',
    'panel.subtitle.other': '{active} of {total} active',

    'row.accounts.one': '{count} account',
    'row.accounts.other': '{count} accounts',
    'row.unused': 'unused',
    'row.active': '"{category}" active',
    'row.actionsMenu': '"{category}" actions',
    'row.rename': 'Rename',
    'row.addValue': 'value',
    'row.addValueLabel': 'New value for "{category}"',
    'row.addValueSubmit': 'Add value',
    'row.addValueCancel': 'Cancel',
    'row.remove': 'Delete',
    'row.single': 'One per account',
    'row.warning':
      'This name reads as recording a person’s religion, party, health or sexual orientation. Tags describe accounts; check before using it.',
    'row.locked':
      'Required: every account has exactly one alignment. You can add values and change icons.',

    'value.remove': 'Delete value',
    'value.countsAs': 'Counts as',
    'value.countsAsOption': 'counts as {value}',

    'icon.category': '"{name}" icon',
    'icon.value': '"{name}" icon',
    'icon.search': 'Search icons',
    'icon.none': 'No icon found.',
    'icon.heading': 'Icons',
    'icon.inheritCategory': 'Use the category icon',
    'icon.inheritDefault': 'Use the default icon',

    'remove.title': 'Delete "{name}"?',
    'remove.category.one':
      'The category and its values go, and {count} account loses those tags. This cannot be undone.',
    'remove.category.other':
      'The category and its values go, and {count} accounts lose those tags. This cannot be undone.',
    'remove.value':
      'The value goes and the accounts carrying it lose that tag. This cannot be undone.',
    'remove.alignmentValue':
      'The value goes and the accounts carrying it move to "{fallback}". This cannot be undone.',
    'remove.submit': 'Delete',

    'scope.label': 'Analysis scope',
    'scope.ALL': 'All posts',
    'scope.RELATED': 'Related only',
    'scope.help':
      'Which posts from accounts with this alignment get metrics, comments, likers and comment analysis.',

    'create.trigger': 'New tag',
    'create.title': 'New tag',
    'create.label': 'Category name',
    'create.submit': 'Create',

    'rename.title': 'Rename "{category}"',
    'rename.label': 'New name',
    'rename.submit': 'Rename',

    'empty.title': 'No tags yet',
    'empty.body': 'Create a tag to get started.',
  },
);

export const tgt = tagsCatalogue.t;
export const tgp = tagsCatalogue.plural;
